import { useState } from 'react';

import { formatNumberWithCurrency } from '../../../../base/utils';
import { Input } from '../../../../helbest';
import walletStyles from '../Wallet.module.css';
import styles from './GiftCredit.module.css';

export const GiftCredit = ({ currentCredit, postGiftCreditCode }) => {
  const [discount_code, set_discount_code] = useState();

  const handleGiftCreditCode = () => {
    postGiftCreditCode(discount_code);
  };

  return (
    <div className={walletStyles.WalletSection}>
      <div className={walletStyles.CurrentCreditWrapper}>
        <div>اعتبار فعلی:</div>
        <div className="CurrentCreditValue">{formatNumberWithCurrency(currentCredit)}</div>
      </div>
      <div className={styles.GiftCreditFormWrapper}>
        <Input
          className={styles.GiftCreditInput}
          data={discount_code}
          dataHandler={(value) => set_discount_code(value)}
          inputClassName={styles.GiftCreditInputSuffix}
          placeholder="کد شارژ هدیه خود را وارد نمایید"
        />
        <div className="flex-i center-content">
          <button className={walletStyles.SubmitBtn} onClick={handleGiftCreditCode} type="button">
            ثبت کد
          </button>
        </div>
      </div>
    </div>
  );
};
